import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { ProductCard } from "@/components/ProductCard";

export default function BestSellers({ products }) {
  return (
    <section data-testid="best-sellers-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <div className="flex items-end justify-between">
          <SectionHeading
            index="02"
            overline="Proven Favourites"
            title="Best Sellers"
            sub="The products our customers reorder, gift, and recommend — rated 4.7 and above."
          />
          <Reveal delay={0.1} className="mb-10 hidden shrink-0 sm:mb-14 sm:block">
            <Link
              to="/best-sellers"
              data-testid="view-all-best-sellers"
              className="group inline-flex items-center gap-2 text-sm font-semibold text-neutral-900 transition-colors hover:text-neutral-500"
            >
              View All <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {products.slice(0, 8).map((p, i) => (
            <Reveal key={p.slug} delay={(i % 4) * 0.07}>
              <ProductCard product={p} />
            </Reveal>
          ))}
        </div>
        <div className="mt-10 text-center sm:hidden">
          <Link to="/best-sellers" className="text-sm font-semibold text-neutral-900 underline underline-offset-4">
            View All Best Sellers
          </Link>
        </div>
      </div>
    </section>
  );
}
